/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { WorkspaceDTO, WorkspaceFilterDTO, UserDTO, ValueListDTO, PeopleFilterDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';

interface IWorkspaceMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const WorkspaceMaintenance: React.FC<IWorkspaceMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [internalResponsibleList, setInternalResposibleList] = useState<UserDTO[]>([]);
    const [externalResponsibleList, setExternalResposibleList] = useState<UserDTO[]>([]);
    const [createdByList, setCreatedList] = useState<UserDTO[]>([]);
    
    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [workspaceDTO, setWorkspaceDTO] = useState<WorkspaceDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setWorkspaceDTO({
            ...workspaceDTO,
            name: '',
            code: '',
            internalResponsibleId: '',
            externalResponsibleId: '',
            createdById: '',
            companyId: userInfo.user.companyId
        } as WorkspaceDTO);

        if(isOpenMaintenance){
            handleResponsibleGetAllViewAsync(setInternalResposibleList);
            handleResponsibleGetAllViewAsync(setExternalResposibleList);
            handleResponsibleGetAllViewAsync(setCreatedList);   
            handleUserGetAllAsync();
            handleGetWorkspaceByIdAsync();
        }
    }, [data, isOpenMaintenance]);

    const handleResponsibleGetAllViewAsync = useCallback(async (setList: any) => {
        const peopleFilterDTO: PeopleFilterDTO = {
            companyId: '',
            isServiceAccount: false,
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setList, showMessage);
    }, []);
    
    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            workspaceId: userInfo.user.workspaceId,
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleGetWorkspaceByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('testingsphere.workspace', data.id, setLoading, setWorkspaceDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = workspaceDTO as WorkspaceDTO;

        if (workspaceDTO?.id === '' || workspaceDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('testingsphere.workspace', dto, setWorkspaceDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('testingsphere.workspace', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [workspaceDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='WORKSPACE DETAILS'
                icon='grid_view_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={9}>
                            <TextFieldInput
                                id='name'
                                label='Name'
                                value={workspaceDTO?.name}
                                setValue={setWorkspaceDTO}
                                obj={workspaceDTO}
                                required={true}
                                maxLength={10}
                                autoFocus={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='code'
                                label='Code'
                                value={workspaceDTO?.code}
                                setValue={setWorkspaceDTO}
                                obj={workspaceDTO}
                                required={true}
                                maxLength={5}
                                transformCase='uppercase'
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='internalResponsibleId'
                                label='Internal Responsible'
                                placeholder='Internal Reposponsible'
                                value={workspaceDTO?.internalResponsibleId}
                                setValue={setWorkspaceDTO}
                                obj={workspaceDTO}
                                valueList={internalResponsibleList}
                                hasNoneSelect={true}
                                labelKey='fullName'
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='externalResponsibleId'
                                label='External Responsible'
                                placeholder='External Reposponsible'
                                value={workspaceDTO?.externalResponsibleId}
                                setValue={setWorkspaceDTO}
                                obj={workspaceDTO}
                                valueList={externalResponsibleList}
                                hasNoneSelect={true}
                                labelKey='fullName'
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextFieldInput
                                id='description'
                                label='Description'
                                value={workspaceDTO?.description}
                                setValue={setWorkspaceDTO}
                                obj={workspaceDTO}
                                required={false}
                                maxLength={400}
                                multiline={true}
                                rows={2}
                            />
                        </Grid>
                        {workspaceDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={workspaceDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === workspaceDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(workspaceDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === workspaceDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(workspaceDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};